import React from 'react';
import Modal from 'react-bootstrap/Modal';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import InputField from '../Reusable/InputField';
import { handleErrorMessage } from '../../utils';
import ErrorHandler from '../Reusable/ErrorHandler';
import { Row, Col, Card, Table } from 'react-bootstrap';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

class ModalForUpdateMunicipalityName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      place: props.municipality?.place || null,
      name: props.municipality?.name || '',
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    const { name, place } = this.state;
    const { signalOfUpdate, t } = this.props || {},
      { Errors } = t || {};

    let errors = {};

    if (!name) {
      errors['name'] = Errors?.name;
      hasError = true;
    }

    if (!signalOfUpdate) {
      if (!place) {
        errors['place'] = Errors?.place;
        hasError = true;
      }
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { signalOfUpdate } = this.props || {};

    if (this.handleClientValidation()) {
      return;
    }

    const municipalityForSave = {
      ...this.props.municipality,
      name: this.state.name,
      place: this.state.place,
    };

    signalOfUpdate
      ? this.props.updateMunicipality(municipalityForSave)
      : this.props.createMunicipality(municipalityForSave);
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({
      place: newValue,
    });
  };

  render() {
    const { error, deleteError, t, placeList, signalOfUpdate, municipality } =
        this.props || {},
      { Placeholders, Labels } = t || {};

    const { place, name } = this.state || {};

    const titleModal = municipality ? Labels.titleUpdate : Labels.title;

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={this.props.secondModal && 'secondModal'}
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <h5 className="title mb-4">{titleModal}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="form-group">
                  <div className="col-md-12 mb-4">
                    <InputField
                      name="name"
                      placeholder={Placeholders.name}
                      onChange={this.onChange}
                      value={name}
                      error={handleErrorMessage(
                        error,
                        'name',
                        this.state.errors.name
                      )}
                    />
                  </div>
                  {!signalOfUpdate && (
                    <div className="col-md-12">
                      <ComboBoxAutocomplete
                        data={placeList}
                        text={(place) => place.name}
                        changeValue={(newValue) =>
                          this.changeComboAutocompleteValue('place', newValue)
                        }
                        updateValue={place}
                        wholeObject
                        placeholder={Placeholders.place}
                        error={handleErrorMessage(
                          error,
                          'place',
                          this.state.errors.place
                        )}
                      />
                    </div>
                  )}
                </div>
              </div>
              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForUpdateMunicipalityName,
  'ModalForUpdateMunicipalityName'
);
